import ky, { BeforeRequestHook } from 'ky';

import { EnvConfig } from '../config';

import { localStorageService } from './localStorageService';

import { Geo, Locale, LocalStorageKey } from 'v2/constants';

const setHeaders: BeforeRequestHook = (req) => {
  const locale = localStorageService.get<Locale>(LocalStorageKey.LOCALE);
  const geo = localStorageService.get<Geo>(LocalStorageKey.GEO) ?? Geo.RU;

  req.headers.set('Content-Language', locale ?? Locale.ru_RU);
  req.headers.set('x-geo', geo);
};

export const api = ky.create({
  prefixUrl: EnvConfig.CORE_API_CONTEXT,
  hooks: {
    beforeRequest: [setHeaders],
  },
});

export const fs = ky.create({
  prefixUrl: EnvConfig.FS_API_CONTEXT,
  hooks: {
    beforeRequest: [setHeaders],
  },
});

export const scheduler = ky.create({
  prefixUrl: EnvConfig.SCHEDULER_API_CONTEXT,
});
